const WorkoutSetup = ({ description, pointOne, pointTwo, pointThree }) => {
  return (
    <div className="workout-setup">
      <div className="title">3 Easy Steps</div>
      <div className="description">{description}</div>
      <div className="points">
        <div className="point">
          <div className="number">01</div>
          <div className="details">{pointOne}</div>
        </div>
        <div className="point">
          <div className="number">02</div>
          <div className="details">{pointTwo}</div>
        </div>
        <div className="point">
          <div className="number">03</div>
          <div className="details">{pointThree}</div>
        </div>
      </div>
    </div>
  );
};

export default WorkoutSetup;
